export default __webpack_public_path__ + "static/media/investimentomob.1e3ebb5e.png";